import { render, staticRenderFns } from "./smzb.vue?vue&type=template&id=30d0d2c6&scoped=true"
import script from "./smzb.vue?vue&type=script&lang=js"
export * from "./smzb.vue?vue&type=script&lang=js"
import style0 from "./smzb.vue?vue&type=style&index=0&id=30d0d2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d0d2c6",
  null
  
)

export default component.exports